import { useEffect, useRef, useState } from 'react';
import { searchAddress } from '../../api/addressApi';
import { MapPickerOverlay } from './MapPicker.styles';

const MapPicker = ({ show, lat, lon, onSelect, onClose }) => {
    const mapRef = useRef(null);
    const markerRef = useRef(null);
    const infoWindowRef = useRef(null);
    const clickedPos = useRef({ lat, lon });
    const onSelectRef = useRef(onSelect);
    const [searchResults, setSearchResults] = useState(null);

    onSelectRef.current = onSelect;

    useEffect(() => {
        if (!show || !lat || !lon) return;

        let initLat = lat;
        let initLon = lon;
        clickedPos.current = { lat: initLat, lon: initLon };

        let timer = setTimeout(() => {
            let container = document.getElementById("mapPicker");
            if (!container) return;

            if (mapRef.current && markerRef.current) {
                mapRef.current.setCenter({ lat: initLat, lng: initLon });
                markerRef.current.setPosition({ lat: initLat, lng: initLon });
                if (infoWindowRef.current) {
                    infoWindowRef.current.open(mapRef.current, markerRef.current);
                }
                return;
            }

            let map = new window.google.maps.Map(container, {
                center: { lat: initLat, lng: initLon },
                zoom: 10,
                disableDefaultUI: false,
                zoomControl: true,
                streetViewControl: false,
                mapTypeControl: false,
                fullscreenControl: false,
                clickableIcons: false
            });
            mapRef.current = map;

            let marker = new window.google.maps.Marker({
                position: { lat: initLat, lng: initLon },
                map: map,
                draggable: true
            });
            markerRef.current = marker;

            let infoWindow = new window.google.maps.InfoWindow({
                content: '<button class="mapPickerSelectBtn">위치 선택</button>',
                disableAutoPan: true,
                pixelOffset: new window.google.maps.Size(0, 8)
            });
            infoWindowRef.current = infoWindow;
            infoWindow.open(map, marker);

            infoWindow.addListener('domready', () => {
                let btn = document.querySelector('.mapPickerSelectBtn');
                if (btn) {
                    btn.onclick = () => {
                        if (onSelectRef.current) {
                            onSelectRef.current(clickedPos.current.lat, clickedPos.current.lon);
                        }
                    };
                }
            });

            marker.addListener('dragend', () => {
                let pos = marker.getPosition();
                clickedPos.current = { lat: pos.lat(), lon: pos.lng() };
                infoWindow.open(map, marker);
            });

            map.addListener('click', (e) => {
                let pos = e.latLng;
                marker.setPosition(pos);
                clickedPos.current = { lat: pos.lat(), lon: pos.lng() };
                infoWindow.open(map, marker);
            });
        }, 50);

        return () => {
            clearTimeout(timer);
            mapRef.current = null;
            markerRef.current = null;
            infoWindowRef.current = null;
        };
    }, [show, lat, lon]);

    const handleClose = () => {
        setSearchResults(null);
        if (onClose) onClose();
    };

    const handleSearch = (e) => {
        if (e.key === 'Enter' && e.target.value.trim()) {
            searchAddress(e.target.value.trim(), (results) => {
                setSearchResults(results);
            });
        }
    };

    const handleResultClick = (item) => {
        let newLat = parseFloat(item.lat);
        let newLon = parseFloat(item.lon);
        clickedPos.current = { lat: newLat, lon: newLon };
        setSearchResults(null);
        if (mapRef.current) {
            mapRef.current.setCenter({ lat: newLat, lng: newLon });
            mapRef.current.setZoom(13);
            if (markerRef.current) {
                markerRef.current.setPosition({ lat: newLat, lng: newLon });
            }
            if (infoWindowRef.current && markerRef.current) {
                infoWindowRef.current.open(mapRef.current, markerRef.current);
            }
        }
    };

    if (!show) return null;

    return (
        <MapPickerOverlay>
            <div className='mapWrap'>
                <div className='mapSearch'>
                    <input type="text" placeholder="장소 검색" onKeyDown={handleSearch} />
                    {searchResults && searchResults.length > 0 ?
                        <ul className='searchResultList'>
                            {searchResults.map((item, i) => (
                                <li key={i} onClick={() => handleResultClick(item)}>
                                    {item.display_name}
                                </li>
                            ))}
                        </ul>
                        : null}
                </div>
                <div id="mapPicker"></div>
                <svg className="closeIcon" onClick={handleClose} width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <line x1="6" y1="6" x2="18" y2="18" stroke="#495057" strokeWidth="2" strokeLinecap="round"/>
                    <line x1="18" y1="6" x2="6" y2="18" stroke="#495057" strokeWidth="2" strokeLinecap="round"/>
                </svg>
            </div>
        </MapPickerOverlay>
    );
};

export default MapPicker;
